import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'
import { USER_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'

type Payload = {
  company_name?: string
  country_code?: string
  company_website?: string
  settings?: { language_preference?: string }
}

export const createOrganisation = async (payload: Payload) => {
  try {
    const response = await axios.post(
      `${USER_SERVICE_BASE_URL}/companies`,
      payload
    )

    return response.data
  } catch (error) {
    return extract.error(error)
  }
}
